import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { WorkspaceTemplate } from "@/types";

// #290 (UC-2): Fach-Sicht Workspace-Vorlagen — Entity-Ebene über dem Repo. Die Antworten
// sprechen Fach-Vokabular (id/name/„verwendet von"); die Dateien liefert der geteilte
// RepoContentPanel-Baustein über die git-content-Queries.

export function useWorkspaceTemplates(): UseQueryResult<WorkspaceTemplate[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "workspace-templates", "list"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<WorkspaceTemplate[]>("/workspace-templates");
    },
    enabled: !!session,
  });
}

export function useWorkspaceTemplate(id: string | undefined): UseQueryResult<WorkspaceTemplate> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "workspace-templates", id ?? "_none"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<WorkspaceTemplate>(`/workspace-templates/${encodeURIComponent(id ?? "")}`);
    },
    enabled: !!session && !!id,
  });
}
